// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-c8be4cf2]{border-collapse:collapse}table[data-v-c8be4cf2],td[data-v-c8be4cf2],th[data-v-c8be4cf2]{border:.5px solid #000}.pink-light-kaam[data-v-c8be4cf2]{background-color:#ec81b3}@media print{.pink-light-kaam[data-v-c8be4cf2]{background-color:#ec81b3!important;-webkit-print-color-adjust:exact!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
